<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M31.667 32.5055C32.4412 32.5055 32.8282 32.5055 33.1521 32.4542C34.935 32.1718 36.3333 30.7735 36.6157 28.9906C36.667 28.6667 36.667 28.2796 36.667 27.5054V12.505C36.667 11.7308 36.667 11.3437 36.6157 11.0198C36.3333 9.2369 34.935 7.83857 33.1521 7.55618C32.8282 7.50488 32.4412 7.50488 31.667 7.50488"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M8.33301 32.5055C7.55884 32.5055 7.17175 32.5055 6.84786 32.4542C5.06498 32.1718 3.66669 30.7735 3.38431 28.9906C3.33301 28.6667 3.33301 28.2796 3.33301 27.5054V12.505C3.33301 11.7308 3.33301 11.3437 3.38431 11.0198C3.66669 9.2369 5.06498 7.83857 6.84786 7.55618C7.17175 7.50488 7.55884 7.50488 8.33301 7.50488"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M8.33301 13.3381C8.33301 8.62398 8.33301 6.26689 9.79747 4.80239C11.2619 3.33789 13.619 3.33789 18.333 3.33789H21.6663C26.3804 3.33789 28.7374 3.33789 30.2019 4.80239C31.6663 6.26689 31.6663 8.62398 31.6663 13.3381V26.6718C31.6663 31.386 31.6663 33.743 30.2019 35.2075C28.7374 36.672 26.3804 36.672 21.6663 36.672H18.333C13.619 36.672 11.2619 36.672 9.79747 35.2075C8.33301 33.743 8.33301 31.386 8.33301 26.6718V13.3381Z"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <circle
            cx="20.0009"
            cy="15.4814"
            r="3.80952"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <ellipse
            cx="19.9997"
            cy="25.958"
            rx="6.66667"
            ry="3.80952"
            stroke="currentColor"
            stroke-width="1.6"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "PartnerProfilesIcon",
});
</script>
